import { useCallback } from "react";

import { useDialogsProvider } from "2g-dialogs-provider";
import ZpracDialog from "2g-zprac-dialog";

import { DATA } from "b2b/api/paths";
import useMessages from "b2b/components/zadosti-odbaveni-grid/i18n/useMessages";

export default function useColumnsHandleClick(handleSuccess) {
  const { dialogAcceptTitle, dialogDeclineTitle } = useMessages();
  const { showDialog, hideDialog } = useDialogsProvider();
  const handleClickAccept = useCallback(
    ({ dataRow }) => {
      showDialog(ZpracDialog, {
        method: "put",
        onClose: hideDialog,
        onChangeRequested: hideDialog,
        onSuccess: handleSuccess,
        payload: [dataRow.id],
        title: dialogAcceptTitle(),
        url: DATA.zadostiPotvrzeni()
      });
    },
    [dialogAcceptTitle]
  );
  const handleClickDecline = useCallback(
    ({ dataRow }) => {
      showDialog(ZpracDialog, {
        method: "put",
        onClose: hideDialog,
        onChangeRequested: hideDialog,
        onSuccess: handleSuccess,
        payload: [dataRow.id],
        title: dialogDeclineTitle(),
        url: DATA.zadostiZamitnuti()
      });
    },
    [dialogDeclineTitle]
  );
  return { handleClickAccept, handleClickDecline };
}
